import { render, staticRenderFns } from "./page-list.vue?vue&type=template&id=5475199c&scoped=true&"
import script from "./page-list.vue?vue&type=script&lang=js&"
export * from "./page-list.vue?vue&type=script&lang=js&"
import style0 from "./page-list.vue?vue&type=style&index=0&id=5475199c&scoped=true&lang=css&"
import style1 from "./page-list.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5475199c",
  null
  
)

export default component.exports